export default __webpack_public_path__ + "static/media/Chī Wěn.70e9b4eb.png";